import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Lead, LeadDisqualificationReason } from '../models/lead.model';

export interface CloseLeadData {
  disqualificationReasonId: number;
  disqualificationNotes?: string;
  retryDate?: string;
  isRetryScheduled: boolean;
}

@Component({
  selector: 'app-lead-close-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './lead-close-modal.component.html'
})
export class LeadCloseModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() lead: Partial<Lead> | null = null;
  @Input() disqualificationReasons: LeadDisqualificationReason[] = [];
  @Input() saving = false;

  @Output() confirmed = new EventEmitter<CloseLeadData>();
  @Output() cancelled = new EventEmitter<void>();

  reasonId: number | undefined;
  notes = '';
  retryDate = '';
  isRetryScheduled = false;

  get todayDate(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  get retryDateIsPast(): boolean {
    return !!this.retryDate && this.retryDate < this.todayDate;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true) {
      this.reset();
    }
  }

  reset(): void {
    this.reasonId = undefined;
    this.notes = '';
    this.retryDate = '';
    this.isRetryScheduled = false;
  }

  onReasonChange(newReasonId: number | undefined): void {
    this.reasonId = newReasonId;
    if (newReasonId == null) return;

    const reason = this.disqualificationReasons.find(r => r.id === newReasonId);
    if (reason?.autoReschedule && (reason.defaultRetryDays ?? 0) > 0) {
      const d = new Date();
      d.setDate(d.getDate() + (reason.defaultRetryDays ?? 0));
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      this.retryDate = `${yyyy}-${mm}-${dd}`;
      this.isRetryScheduled = true;
    }
  }

  confirmar(): void {
    if (!this.reasonId) return;
    if (this.retryDateIsPast) return;

    // Convert date string to ISO 8601 OffsetDateTime if provided
    let retryDateISO: string | undefined;
    if (this.retryDate) {
      retryDateISO = new Date(this.retryDate + 'T00:00:00').toISOString();
    }

    this.confirmed.emit({
      disqualificationReasonId: this.reasonId,
      disqualificationNotes: this.notes || undefined,
      retryDate: retryDateISO,
      isRetryScheduled: this.isRetryScheduled
    });
  }

  cancelar(): void {
    this.cancelled.emit();
  }
}
